import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import Linkk from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import Register from "./components/Register/Register";
import studentImage from "./assets/studenttc.svg";
import adminImage from "./assets/adminc.svg";
import educatorImage from "./assets/educatorc.svg";
import guestImage from "./assets/guest.svg";

var pjson = require("./../package.json");
var version = pjson.version;

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Linkk color="inherit" href="https://www.zlipp.in">
        Zlipp LMS
      </Linkk>{" "}
      {new Date().getFullYear()}-{"version :"} {version}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    offset: theme.mixins.toolbar,
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 1000,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    height: "100%",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
}));

export default function Checkout() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar position="fixed" color="default" className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" color="inherit" noWrap>
            Zlipp LMS
          </Typography>
        </Toolbar>
      </AppBar>

      <main className={classes.layout}>
        <br />
        <br />

        <Paper className={classes.paper}>
          <Typography component="h3" variant="h4" align="center" className="mb-4">
            Hey!...Register as
          </Typography>

          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-12 col-sm-6 col-md-3 mt-4">
                <Register
                  url={studentImage}
                  user={"Student"}
                  redirect={"/student"}
                />
              </div>
              <div className="col-12 col-sm-6 col-md-3 mt-4">
                <Register
                  url={adminImage}
                  user={"College"}
                  redirect={"/college"}
                />
              </div>
              <div className="col-12 col-sm-6 col-md-3 mt-4">
                <Register
                  url={educatorImage}
                  user={"Educator"}
                  redirect={"/instructor"}
                />
              </div>
              {/* <div className="col-12 col-sm-6 col-md-3 mt-4">
                <Register
                  url={guestImage}
                  user={"Guest User"}
                  redirect={"/guestUser"}
                />
              </div> */}
            </div>
          </div>
        </Paper>
        <Copyright />
      </main>
    </React.Fragment>
  );
}
